import { HorizontalBar, mixins } from 'vue-chartjs'
export default {
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options', 'cssClasses', 'height', 'width', 'styles'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/views/horizontalchartbar.js